export const ROUTER_PATHS = {
  REVIEW: '/review',
  RESERVATION: '/reservation',
  // 이벤트 예약 (구 시술 선택 예약)
  EVENT_TREATMENT_RESERVATION: '/treatment-reservation',
  // 상담 예약
  CONSULTING_RESERVATION: '/consulting-reservation',
  // 일반 예약
  TREATMENT_RESERVATION: '/clinic-reservation',
  // 재진 예약
  REVISIT_RESERVATION: '/revisit-reservation',
  RESERVATION_COMPLETE: '/reservation-complete',
  RESERVATION_HISTORIES: '/reservation-histories',
  CHAT_REQUEST: '/chat-request',
  AFTER_NOTICES: '/after-notices',

  // 단축 URL 리다이렉트
  SHORT_URL_REDIRECT: '/r/:code',
};
